require('./dropdownFunds.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ components
const FundItem = require('./fundItem');

class FundItemOptions extends React.Component {

    constructor() {
        super();
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
    }

    handleMouseDown (event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onSelect(this.props.option, event);
    }

    handleMouseMove (event) {
        if (this.props.isFocused) return;
        this.props.onFocus(this.props.option, event);
    }

    render () {
        const {option, className} = this.props;
        const account = option;
        const id = `${account.id}_Options_${account.value}`;
        const accountClass = `${className} dropdown-funds__account`;

        return (
            <div
                id={id}
                className={accountClass}
                onMouseDown={this.handleMouseDown}
                onMouseMove={this.handleMouseMove}
            >
                <div className="dropdown-funds__account-description dropdown-funds__account-description--height">
                    <FundItem account={account}/>
                </div>
            </div>
        );
    }
}

FundItemOptions.propTypes = {
    className: PropTypes.string,
    onSelect: PropTypes.func,
    option: PropTypes.object,
    onFocus: PropTypes.func,
    isFocused: PropTypes.bool
};

module.exports = FundItemOptions;